export {default} from './TipperCard';
export {TIPPER_CARD_HEIGHT} from './TipperCard.style';
